import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { PrExpansionPanelComponent } from '@app/components/pr-expansion-panel/pr-expansion-panel.component';
import { fromEvent, distinctUntilChanged, throttleTime } from 'rxjs';
import { PrListItemColumnComponent } from './pr-list-item-column/pr-list-item-column.component';

@Component({
    selector: 'pr-list-item',
    templateUrl: './pr-list-item.component.html',
    styleUrls: ['./pr-list-item.component.scss'],
    standalone: false
})
export class PrListItemComponent
  extends PrExpansionPanelComponent
  implements AfterContentInit
{
  alive: boolean = true;
  @Input() entity;
  @Input() iconTemplate: TemplateRef<any>;
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() columns: PrListItemColumnComponent[];
  @Input() expandable: boolean = true;
  @Input() expanded: boolean = false;
  @Input() redirect: boolean = false;
  headersElements: PrListItemColumnComponent[] | null = [];
  bodyElements: PrListItemColumnComponent[] | null = [];
  @Input() maxHeaderElems = 5;
  private defaultMaxElems: number | null = null;

  constructor(private bp: BreakpointObserver) {
    super();

    fromEvent(window, 'resize')
      .pipe(distinctUntilChanged())
      .subscribe(() => this.init());
  }

  ngAfterContentInit(): void {
    this.defaultMaxElems = this.maxHeaderElems;
    this.init();
  }

  init() {
    this.breakpointChanged();
    this.dispatchHeaderElements();
  }

  dispatchHeaderElements() {
    this.headersElements = this.columns.filter(
      (e, i) => i < this.maxHeaderElems,
    );
    this.bodyElements = this.columns.filter((e, i) => i >= this.maxHeaderElems);
  }

  breakpointChanged() {
    const max = this.defaultMaxElems ?? 5;
    if (
      this.bp.isMatched(Breakpoints.Large) ||
      this.bp.isMatched(Breakpoints.XLarge)
    ) {
      this.maxHeaderElems = max;
    } else if (this.bp.isMatched(Breakpoints.Medium)) {
      this.maxHeaderElems = Math.min(max, 4);
    } else if (this.bp.isMatched(Breakpoints.Small)) {
      this.maxHeaderElems = Math.min(max, 3);
    } else if (this.bp.isMatched('(min-width:500px)')) {
      this.maxHeaderElems = Math.min(max, 2);
    } else {
      this.maxHeaderElems = 1;
    }
  }
}
